import { numberToReal } from "services/utils/mask"
import * as ActionTypes from "../action-types"

const INVOICE_DISPUTING_INITIAL_STATE = {
  loading: false,
  error: false,
  invoiceValue: { data: [], loading: false },
  interestFines: { data: [], loading: false },
  readjustmentIgp: { data: [], loading: false },
  readjustmentAnatel: { data: [], loading: false },
  cancellationValue: { data: [], loading: false },
  nrcValue: { data: [], loading: false },
  adjustment: { data: [], loading: false }
}

const getInvoiceValueFromResponse = (response) => {
  const messages = []

  if (!!response && !!response.data) {
    response.data.forEach((information) => {
      messages.push({
        description: "Valor da fatura:",
        invoiceInfo: `R$ ${numberToReal(information.AMOUNT)}`
      })
    })
  }

  return messages
}

const getMessageFromResponse = (response) => {
  const messages = []

  if (!!response && !!response.data) {
    response.data.forEach((information) => {
      messages.push(information.MESSAGE)
    })
  }

  return messages
}

const getAdjustmentFromResponse = (response) => {
  const messages = []

  if (!!response && !!response.data) {
    response.data.forEach((information) => {
      if (information.AMOUNT !== 0) {
        messages.push("Valor de reajuste: R$ " + information.AMOUNT)
      }
    })
  }

  return messages
}

export function invoiceDisputing(
  state = INVOICE_DISPUTING_INITIAL_STATE,
  action
) {
  switch (action.type) {
    case ActionTypes.GET_INVOICE_VALUE:
      return {
        ...state,
        loading: true,
        invoiceValue: { ...state.invoiceValue, loading: true }
      }

    case ActionTypes.GET_INVOICE_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        invoiceValue: {
          data: getInvoiceValueFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_INVOICE_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        invoiceValue: { ...state.invoiceValue, loading: false }
      }

    case ActionTypes.GET_INTEREST_FINES:
      return {
        ...state,
        loading: true,
        interestFines: { ...state.interestFines, loading: true }
      }

    case ActionTypes.GET_INTEREST_FINES_SUCCESS:
      return {
        ...state,
        loading: false,
        interestFines: {
          data: getMessageFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_INTEREST_FINES_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        interestFines: { ...state.interestFines, loading: false }
      }

    case ActionTypes.GET_READJUSTMENT_IGP:
      return {
        ...state,
        loading: true,
        readjustmentIgp: { ...state.readjustmentIgp, loading: true }
      }

    case ActionTypes.GET_READJUSTMENT_IGP_SUCCESS:
      return {
        ...state,
        loading: false,
        readjustmentIgp: {
          data: getMessageFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_READJUSTMENT_IGP_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        readjustmentIgp: { ...state.readjustmentIgp, loading: false }
      }

    case ActionTypes.GET_READJUSTMENT_ANATEL:
      return {
        ...state,
        loading: true,
        readjustmentAnatel: { ...state.readjustmentAnatel, loading: true }
      }

    case ActionTypes.GET_READJUSTMENT_ANATEL_SUCCESS:
      return {
        ...state,
        loading: false,
        readjustmentAnatel: {
          data: getMessageFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_READJUSTMENT_ANATEL_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        readjustmentAnatel: { ...state.readjustmentAnatel, loading: false }
      }

    case ActionTypes.GET_CANCELLATION_VALUE:
      return {
        ...state,
        loading: true,
        cancellationValue: { ...state.cancellationValue, loading: true }
      }

    case ActionTypes.GET_CANCELLATION_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        cancellationValue: {
          data: getMessageFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_CANCELLATION_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        cancellationValue: { ...state.cancellationValue, loading: false }
      }

    case ActionTypes.GET_NRC_VALUE:
      return {
        ...state,
        loading: true,
        nrcValue: { ...state.nrcValue, loading: true }
      }

    case ActionTypes.GET_NRC_VALUE_SUCCESS:
      return {
        ...state,
        loading: false,
        nrcValue: {
          data: getMessageFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_NRC_VALUE_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        nrcValue: { ...state.nrcValue, loading: false }
      }

    case ActionTypes.GET_ADJUSTMENT:
      return {
        ...state,
        loading: true,
        adjustment: { ...state.adjustment, loading: true }
      }

    case ActionTypes.GET_ADJUSTMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        adjustment: {
          data: getAdjustmentFromResponse(action.payload),
          loading: false
        }
      }

    case ActionTypes.GET_ADJUSTMENT_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        adjustment: { ...state.adjustment, loading: false }
      }

    case ActionTypes.SEND_INVOICE_DISPUTING_FILE:
      return { ...state, loading: true }

    case ActionTypes.SEND_INVOICE_DISPUTING_FILE_SUCCESS:
      return { ...state, error: false, loading: false }

    case ActionTypes.SEND_INVOICE_DISPUTING_FILE_FAIL:
      return { ...state, error: true, loading: false }

    case ActionTypes.SAVE_INVOICE_DISPUTING:
      return { ...state, loading: true }

    case ActionTypes.SAVE_INVOICE_DISPUTING_SUCCESS:
      return { ...state, error: false, loading: false }

    case ActionTypes.SAVE_INVOICE_DISPUTING_FAIL:
      return { ...state, error: true, loading: false }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/invoiceDisputing/reducer.js